<template>
  <span :class="[difference > 0 ? 'bg-[#BEFCDE] text-[#34A770]' : 'bg-[#FCBEBE] text-[#E31A1A]', `py-[5px] px-[4px] text-[${textSize}px] leading-[${textSize}px] rounded-lg font-normal`]">{{ `${difference >= 0 ? '+' : '' }${difference}` }}%</span>
</template>

<script>
/**
 * @component BadgeLight
 * @description A badge component with a light background and text color based on the difference value.
 */
export default {
  props: {
    difference: {
      type: Number,
      default: 0,
    },
    textSize: {
      type: String,
      default: '10',
    },
  },
}
</script>
